/**
 * Variant Drawer — Quick Add from Collection pages
 * Pill/dropdown option selectors · image gallery · custom size input
 */
(function () {
  if (customElements.get('variant-drawer-trigger')) return;

  var drawer   = document.getElementById('Variant-Drawer');
  var overlay  = document.getElementById('Variant-Drawer-Overlay');
  if (!drawer || !overlay) return;

  var heroWrap  = document.getElementById('vd-hero');
  var heroImg   = document.getElementById('vd-hero-img');
  var heroPrev  = document.getElementById('vd-hero-prev');
  var heroNext  = document.getElementById('vd-hero-next');
  var headerImg = document.getElementById('vd-header-img');
  var titleEl   = document.getElementById('vd-title');
  var priceEl   = document.getElementById('vd-price');
  var optionsEl = document.getElementById('vd-options');
  var addBtn    = document.getElementById('vd-add-btn');
  var viewLink  = document.getElementById('vd-view-link');

  drawer.querySelectorAll('.vd-close').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
  });

  var PILL_THRESHOLD = 6;
  var currentProduct = null;
  var selected = {};
  var productImages = [];
  var heroIndex = 0;
  var cache = new Map();

  function openDrawer() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    currentProduct = null;
    selected = {};
  }

  /* ── Helpers ── */
  function fetchProduct(handle) {
    if (cache.has(handle)) return Promise.resolve(cache.get(handle));
    var url = (theme.routes.root_url + '/products/' + handle + '.js').replace('//', '/');
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) { cache.set(handle, d); return d; });
  }

  function formatMoney(cents) {
    var a = (cents / 100).toFixed(2);
    var n = Math.round(cents / 100).toString();
    var fmt = (theme.settings.money_with_currency_format || '${{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace('{{amount}}', a).replace('{{amount_no_decimals}}', n)
      .replace('{{amount_with_comma_separator}}', a.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).trim();
  }

  function sizedImg(url, size) {
    return url ? url.replace(/(_\d+x\d+)?(\.[^.]+)(\?.*)?$/, '_' + size + '$2$3') : '';
  }

  function rawImgSrc(v, product) {
    var r = (v && v.featured_image && v.featured_image.src) || (v && v.featured_image) || product.featured_image;
    return (typeof r === 'object' && r !== null) ? (r.src || '') : (r || '');
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function isCustom(val) { return /custom/i.test(val); }

  /* ── Image gallery ── */
  function setHeroImage(idx) {
    if (!productImages.length) return;
    heroIndex = ((idx % productImages.length) + productImages.length) % productImages.length;
    var newSrc = sizedImg(productImages[heroIndex], '600x600');
    if (heroImg.src.indexOf(newSrc.split('?')[0]) !== -1) return; // same image
    heroImg.style.opacity = '0';
    heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
    heroImg.src = newSrc;
  }

  if (heroPrev) heroPrev.addEventListener('click', function () { setHeroImage(heroIndex - 1); });
  if (heroNext) heroNext.addEventListener('click', function () { setHeroImage(heroIndex + 1); });

  /* ── Variant matching ── */
  function findVariant() {
    if (!currentProduct) return null;
    var opts = currentProduct.options;
    for (var i = 0; i < opts.length; i++) {
      if (!selected[opts[i].name]) return null;
    }
    return currentProduct.variants.find(function (v) {
      return currentProduct.options.every(function (opt) {
        return v['option' + opt.position] === selected[opt.name];
      });
    }) || null;
  }

  function getAvailable(optName) {
    var pos = currentProduct.options.find(function (o) { return o.name === optName; }).position;
    var avail = new Set();
    currentProduct.variants.forEach(function (v) {
      if (!v.available) return;
      var ok = true;
      currentProduct.options.forEach(function (opt) {
        if (opt.name === optName) return;
        if (selected[opt.name] && v['option' + opt.position] !== selected[opt.name]) ok = false;
      });
      if (ok) avail.add(v['option' + pos]);
    });
    return avail;
  }

  /* ── Update display ── */
  function updateDisplay() {
    var v = findVariant();
    if (v) {
      var src = rawImgSrc(v, currentProduct);
      if (src) {
        var newHeroSrc = sizedImg(src, '600x600');
        if (heroImg.src !== newHeroSrc) {
          heroImg.style.opacity = '0';
          heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
          heroImg.src = newHeroSrc;
        }
        headerImg.src = sizedImg(src, '200x200');
        // Sync gallery index to variant image
        var srcBase = src.replace(/_\d+x\d+/, '').split('?')[0];
        for (var i = 0; i < productImages.length; i++) {
          if (productImages[i].replace(/_\d+x\d+/, '').split('?')[0] === srcBase) {
            heroIndex = i; break;
          }
        }
      }
      priceEl.textContent = formatMoney(v.price);
      addBtn.disabled = false;
    } else {
      addBtn.disabled = true;
    }
  }

  function updateStates() {
    currentProduct.options.forEach(function (opt) {
      var avail = getAvailable(opt.name);
      // Pills
      optionsEl.querySelectorAll('[data-option="' + opt.name + '"] .vd-pill').forEach(function (pill) {
        var val = pill.dataset.value;
        pill.classList.toggle('vd-pill--selected', selected[opt.name] === val);
        pill.classList.toggle('vd-pill--disabled', !avail.has(val));
      });
      // Dropdown
      var sel = optionsEl.querySelector('[data-option="' + opt.name + '"] select');
      if (sel) {
        sel.value = selected[opt.name] || '';
        Array.from(sel.options).forEach(function (o) {
          if (o.value) o.disabled = !avail.has(o.value);
        });
      }
    });

    // Custom size input visibility
    var customWrap = optionsEl.querySelector('.vd-custom-input');
    if (customWrap) {
      var sizeOpt = currentProduct.options.find(function (o) { return /size/i.test(o.name); });
      customWrap.style.display = (sizeOpt && isCustom(selected[sizeOpt.name])) ? 'block' : 'none';
    }

    updateDisplay();
  }

  /* ── Render ── */
  function renderOptions(product) {
    currentProduct = product;
    selected = {};

    // Images array
    productImages = (product.images || []).map(function (img) {
      return (typeof img === 'object') ? (img.src || '') : (img || '');
    });
    var firstSrc = rawImgSrc(null, product);
    if (firstSrc) {
      heroImg.src = sizedImg(firstSrc, '600x600');
      headerImg.src = sizedImg(firstSrc, '200x200');
      heroWrap.style.display = '';
      headerImg.style.display = '';
      heroIndex = 0;
    } else {
      heroWrap.style.display = 'none';
      headerImg.style.display = 'none';
    }
    // Show/hide gallery arrows
    var hasMulti = productImages.length > 1;
    if (heroPrev) heroPrev.style.display = hasMulti ? '' : 'none';
    if (heroNext) heroNext.style.display = hasMulti ? '' : 'none';

    titleEl.textContent = product.title;
    priceEl.textContent = formatMoney(product.price);
    viewLink.href = product.url;

    // Build HTML
    var html = '';
    product.options.forEach(function (opt) {
      var seen = new Set();
      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + opt.position];
        if (!seen.has(val)) { seen.add(val); values.push(val); }
      });

      html += '<div class="vd-group" data-option="' + esc(opt.name) + '">';
      html += '<p class="vd-group__label">' + esc(opt.name) + '</p>';

      if (values.length > PILL_THRESHOLD) {
        // Dropdown
        html += '<select class="vd-select">';
        values.forEach(function (val) {
          html += '<option value="' + esc(val) + '">' + esc(val) + '</option>';
        });
        html += '</select>';
      } else {
        // Pills
        html += '<div class="vd-group__pills">';
        values.forEach(function (val) {
          html += '<button class="vd-pill" data-value="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    // Custom size textarea
    html += '<div class="vd-custom-input" style="display:none;">';
    html += '<label class="vd-group__label">Custom Size-Add Note</label>';
    html += '<textarea class="vd-textarea" id="vd-custom-note" rows="3" placeholder="Custom width: 7–17mm (Almond thumbs up to 18mm). e.g. L: 15, 11, 12, 11, 8 / R: 15, 11, 12, 10, 8 — thumb to pinky. List both hands if different."></textarea>';
    html += '</div>';

    // Description
    if (product.description) {
      var desc = product.description.replace(/<[^>]*>/g, '').trim();
      if (desc.length > 200) desc = desc.substring(0, 200) + '…';
      if (desc) {
        html += '<div class="vd-desc">' + desc + '</div>';
      }
    }

    optionsEl.innerHTML = html;
    optionsEl.scrollTop = 0;

    // Bind pills
    optionsEl.querySelectorAll('.vd-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('vd-pill--disabled')) return;
        var optName = pill.closest('.vd-group').dataset.option;
        var val = pill.dataset.value;
        selected[optName] = (selected[optName] === val) ? undefined : val;
        if (!selected[optName]) delete selected[optName];
        updateStates();
      });
    });

    // Bind dropdowns
    optionsEl.querySelectorAll('.vd-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var optName = sel.closest('.vd-group').dataset.option;
        if (sel.value) { selected[optName] = sel.value; } else { delete selected[optName]; }
        updateStates();
      });
    });

    // Default: select first available variant's options
    var firstAvail = product.variants.find(function (v) { return v.available; });
    if (firstAvail) {
      product.options.forEach(function (opt) {
        selected[opt.name] = firstAvail['option' + opt.position];
      });
    }

    addBtn.classList.remove('loading');
    updateStates();

    // Preload all product images for instant gallery switching
    productImages.forEach(function (src) {
      if (src) { var img = new Image(); img.src = sizedImg(src, '600x600'); }
    });
  }

  /* ── Add to cart ── */
  function getSectionsKeys() {
    return [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }
  function parseSectionHTML(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : '';
  }

  addBtn.addEventListener('click', function () {
    var v = findVariant();
    if (!v || addBtn.classList.contains('loading')) return;

    addBtn.classList.add('loading');
    addBtn.disabled = true;

    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', 1);

    // Custom size note as line item property
    var noteEl = document.getElementById('vd-custom-note');
    if (noteEl && noteEl.value.trim()) {
      fd.append('properties[Custom Size Note]', noteEl.value.trim());
    }

    fd.append('sections', getSectionsKeys().map(function (s) { return s.section; }));
    fd.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.error('ATC error:', res.description); addBtn.disabled = false; return; }
        getSectionsKeys().forEach(function (sec) {
          var el = document.getElementById(sec.id);
          if (!el || !res.sections || !res.sections[sec.section]) return;
          (el.querySelector(sec.selector) || el).innerHTML = parseSectionHTML(res.sections[sec.section], sec.selector);
        });
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: res.hasOwnProperty('items') ? res.items[0] : res }
        }));
        closeDrawer();
        var cd = document.getElementById('Cart-Drawer');
        if (cd && typeof cd.open === 'function') cd.open();
      })
      .catch(function (e) { console.error('VD ATC error:', e); })
      .finally(function () { addBtn.classList.remove('loading'); });
  });

  /* ── Trigger custom element ── */
  class VariantDrawerTrigger extends HTMLElement {
    connectedCallback() { this.addEventListener('click', this._onClick.bind(this)); }
    _onClick(e) {
      e.preventDefault(); e.stopPropagation();
      var handle = this.dataset.productHandle;
      if (!handle || this.classList.contains('loading')) return;
      optionsEl.innerHTML = '<div class="vd-loading"></div>';
      titleEl.textContent = ''; priceEl.textContent = '';
      heroWrap.style.display = 'none'; headerImg.style.display = 'none';
      addBtn.disabled = true;
      openDrawer();
      this.classList.add('loading');
      var self = this;
      fetchProduct(handle).then(renderOptions)
        .catch(function () { optionsEl.innerHTML = '<p style="padding:20px;text-align:center;color:#999;">Failed to load.</p>'; })
        .finally(function () { self.classList.remove('loading'); });
    }
  }
  customElements.define('variant-drawer-trigger', VariantDrawerTrigger);
})();